"use client";

import { withRedirect } from "@/lib/auth-flow";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { ComponentProps, useEffect, useState } from "react";

type Props = Omit<ComponentProps<typeof Link>, "href"> & { to: "/sign-in" | "/sign-up" };

/** Links to an auth page and returns the visitor to the current path and query afterwards. */
export function AuthLink({ to, ...props }: Props) {
  const pathname = usePathname();
  const [search, setSearch] = useState("");
  // Read after mount so static pages need no Suspense boundary for useSearchParams.
  useEffect(() => setSearch(window.location.search), [pathname]);

  return <Link href={withRedirect(to, `${pathname}${search}`)} {...props} />;
}
